import {mensajesModal} from "../utils";

export const nombreBancoBin = (event,action,newTarjet,tid,errorForm,methods) => {
    if(event.target.value.length === 7){
        methods.dispatch(action.getBanco(newTarjet, tid))
        .then((response) => {
            if (response.data.nombreBanco && response.data.nombreBanco !== "") {
                methods.setBanco(response.data.nombreBanco);
                methods.setForm({
                    ...errorForm,
                    banco: false,
                });
                methods.dispatch(action.setDisabledButtonPago("inpBanco",true));
            } else {
                methods.setBanco("")
                methods.dispatch(action.setDisabledButtonPago("inpBanco",false));
            }
        })
        .catch((error) => {
            methods.setBanco("");
            methods.setForm({
                ...errorForm,
                invalidCard: false,
                numeroTarjeta: false
            });
            methods.dispatch(action.setDisabledButtonPago("inpBanco",false));
            console.error(error);
        });
    }
}

export const handleChanges = (event,creditCardPago,errorForm,
    cvvTemp,methods) => {
    if (
        event.target.name === "numeroTarjeta" ||
        event.target.name === "codigoCvv" ||
        event.target.name === "fchVencimiento"
        ) {
        const esValido = event.target.validity.valid;
        if (esValido) {
            if (event.target.name === "fchVencimiento") {
                const fecha = methods.formatFchExpire(event.target.value);
                methods.setCreditCardPago({
                    ...creditCardPago,
                    fchVencimiento: fecha,
                });
            } else if( event.target.name === "codigoCvv"){
                const newCvv = cvvTemp+event.target.value.slice(-1);
                const maskCvv = creditCardPago.codigoCvv + "*";
                methods.setCreditCardPago({
                    ...creditCardPago,
                    codigoCvv: event.target.value,
                });
                methods.setForm({
                    ...errorForm,
                    [event.target.name]: false,
                });
                if(event.target.value.length < cvvTemp.length){
                    const newLongCvv = cvvTemp.slice(0,event.target.value.length);
                    methods.setCvvTemp(newLongCvv);
                    methods.setCreditCardPago({
                        ...creditCardPago,
                        codigoCvv: event.target.value
                    });
                }
                else{
                    methods.setCvvTemp(newCvv);
                    methods.setCreditCardPago({
                        ...creditCardPago,
                        codigoCvv: maskCvv
                    });
                }
            }
        }
    } else {
        elseHandleChanges(event,methods.setBanco,methods.setForm,methods.setCreditCardPago,
            errorForm,creditCardPago); 
    }
}

export const elseHandleChanges = (event,setBanco,setForm,setCreditCardPago,
    errorForm,creditCardPago) => {
    if(event.target.name === "banco"){
        setBanco(event.target.value)
    }else{
        setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value,
        });
    }
}

export const verifyAmex = (event,creditCardPago,methods) => {
    methods.setTarjetaTemp(newTarjet);
    methods.setCreditCardPago({
        ...creditCardPago,
        [event.target.name]:  event.target.value
    });
    const regexpAmex = /^3[47][0-9]{13}$/i.test(newTarjet);
    if(regexpAmex){
        event.target.pattern = "[0-9' '*]{0,17}";
        methods.setTipoTarjeta(amex);
        methods.setTypeNumCard("amex");
        methods.setSizeCvv(4);
        methods.setLongCard(17);
    }
    else {
        event.target.pattern = "[0-9' '*]{0,19}";
        methods.setLongCard(19);
        methods.setSizeCvv(3);
    }
}

export const handlePattern = (event, typeNumCard) => {
    if (event.target.name === "numeroTarjeta") {
        event.target.pattern = typeNumCard === "amex"?  "[0-9 *]{0,17}": "[0-9 *]{0,19}" ;
    } else if (event.target.name === "fchVencimiento") {
        event.target.pattern = "[0-9/]{0,5}";
    } else if (event.target.name === "codigoCvv") {
        event.target.pattern = typeNumCard === "amex"?"[0-9*]{0,4}":"[0-9*]{0,3}";
    }
};

export const handleKeys = (e, setInvalidChar) => {
    if(e.keyCode === 32 || e.keyCode === 221 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 37){
        e.preventDefault();
        setInvalidChar(true);
    }else{
        setInvalidChar(false);
    }
}

export const handleCloseRegresar = (e,setOpenModales,openModales,handleRegresar) => {
    if(e === "buttonIcon" || e === "button1"){
        setOpenModales({
            ...openModales,
            modalRegresar: false
        });
    }else{
        handleRegresar(false)
    }
}

export const hanldeChangeTarjet = (event,methods,typeNumCard,maskAmex,invalidChar) => {
    if(event.target.value.length === 1){
        methods.handlePattern(event, typeNumCard);
    }
    const esValido = event.target.validity.valid;
    if(esValido && !maskAmex && !invalidChar){
        methods.maskViMaGen(event);
    }else if(esValido && maskAmex && !invalidChar){
        methods.maskTarjetAmex(event);
    }
}

export const erroresPago = (event,varState,creditCardPago,
    errorForm,action,methods) => {
    if (
        event.target.name === "numeroTarjeta" &&
        creditCardPago.numeroTarjeta.length === varState.longCard
    ) {
        methods.errorGenCard(varState.typeNumCard,errorForm,methods.setForm,methods.dispatch,action);
    }else if(event.target.name === "numeroTarjeta" &&
    creditCardPago.numeroTarjeta.length < varState.longCard){
        methods.setForm({...errorForm,invalidCard: true,numeroTarjeta: false});
        methods.dispatch(action.setDisabledButtonPago("inpNumTarjeta",false));
    }else if(event.target.name === 'codigoCvv' && event.target.value.length < varState.sizeCvv){
        methods.setForm({
            ...errorForm,
            codigoCvv: true
        });
    }else if(event.target.name === "fchVencimiento"){
        methods.errorFchVencimiento(event,creditCardPago,errorForm,varState.anoActual,varState.mesActual,methods,action);
    }
}

export const actionPagoBancario = (jsonPago,action,creditCardPago,
    openModales,tid,methods) => {
        methods.setOpenModales({
            ...openModales,
            modalCvv: false, 
            modalErrorPago: false,
            modalProceso: true
        });
    const timer = setInterval(() => {
        methods.setProgress((oldProgress) => {
            if (oldProgress === 100) {
            return 0;
            }
            const diff = 20;
            return Math.min(oldProgress + diff, 100);
        });
        }, 500);
    methods.dispatch(action.postPagoBancario(tid, { ...jsonPago }))
    .then((response) => {
        if (response.status === 200 && response.data.exito) {
            methods.setResponsePAgo({ ...response.data });
            clearInterval(timer);
            methods.setOpenModales({
                ...openModales,
                modalCvv: false,
                modalProceso: false,
                modalDetalle: true
            });
            methods.setProgress(0);
            methods.setCvvTemp("");
        } else if (response.status === 200 && !response.data.exito) {
            switch (response.data.message) {
            case "Ya se tiene un cobro para la referencia":
                methods.setDatosModal({
                    msjTitle: mensajesModal.modalCobroReferencia.msjTitle,
                    msjBody: mensajesModal.modalCobroReferencia.msjBody,
                    withButton: {...mensajesModal.modalCobroReferencia.withButton}
                });
                break;
            case "Pago Rechazado":
                methods.setDatosModal({
                    msjTitle: mensajesModal.modalPagoRechazado.msjTitle,
                    msjBody: mensajesModal.modalPagoRechazado.msjBody,
                    msjBody2: mensajesModal.modalPagoRechazado.msjBody2,
                    withButton: {...mensajesModal.modalPagoRechazado.withButton}
                });
                break;
            case "Tarjeta Rechazada":
                methods.setDatosModal({
                    msjTitle: mensajesModal.modalTarjetaRechazada.msjTitle,
                    msjBody: mensajesModal.modalTarjetaRechazada.msjBody,
                    msjBody2: mensajesModal.modalTarjetaRechazada.msjBody2,
                    withButton: {...mensajesModal.modalTarjetaRechazada.withButton},
                });
                break;
            case "Contacte al emisor":
                methods.setDatosModal({
                    msjTitle: mensajesModal.modalContactaEmisor.msjTitle,
                    msjBody: mensajesModal.modalContactaEmisor.msjBody,
                    withButton: {...mensajesModal.modalContactaEmisor.withButton}
                });
                break;
            default:
                break;
            }
            clearInterval(timer);
            methods.setOpenModales({
                ...openModales,
                modalCvv: false,
                modalProceso: false,
                modalErroresPago: true,
            });
            methods.setProgress(0);
            methods.setCreditCardPago({
                ...creditCardPago,
                codigoCvv: ""
            });
            methods.setCvvTemp("");
        }
    })
    .catch((error) => {
        methods.setDatosModal({
            msjTitle: mensajesModal.modalNoDisponible.msjTitle,
            msjBody: mensajesModal.modalNoDisponible.msjBody,
            msjBody2: mensajesModal.modalNoDisponible.msjBody2,
            withButton: {...mensajesModal.modalNoDisponible.withButton},
        });
        clearInterval(timer);
        methods.setOpenModales({
            ...openModales,
            modalCvv: false,
            modalProceso: false,
            modalErrorPago: true,
        });
        methods.setProgress(0);
        methods.setCreditCardPago({
            ...creditCardPago,
            codigoCvv: ""
        });
        methods.setCvvTemp("");
        console.error(error);
    });
}

export const validRegexpTarjet = (event,newTarjet,creditCardPago,varState,methods) => {
    const regexpMaster = /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/i.test(newTarjet);
    const regexpVisa = /^4[0-9]{12}(?:[0-9]{3})?$/i.test(newTarjet);
    methods.setTarjetaTemp(newTarjet);
    methods.setCreditCardPago({
        ...creditCardPago,
        [event.target.name]:  event.target.value
    });
    if(regexpMaster){ 
        methods.setTipoTarjeta(varState.masterCard);
        methods.setSizeCvv(3);
        methods.setTypeNumCard("master");
        methods.setLongCard(19);
    }else if(regexpVisa){
        methods.setTipoTarjeta(varState.visa);
        methods.setSizeCvv(3);
        methods.setTypeNumCard("visa");
        methods.setLongCard(19);
    }else{
        methods.setTipoTarjeta(varState.genCard);
        methods.setSizeCvv(3);
        methods.setLongCard(19);
        methods.setTypeNumCard("gen");
    }
}

function difLength(length1, length2){
    const generalLength = length1 - length2;
    return(generalLength === 1 || generalLength === 0 || generalLength === -1 )
}

function finalAmex(event,newTarjet,varState,methods){
     if(event.target.value.length === 2 && (newTarjet.includes("34") || newTarjet.includes("37"))){
            methods.setTipoTarjeta(varState.amex);
            methods.setTypeNumCard("amex");
            methods.setSizeCvv(4);
            methods.setLongCard(17);
            methods.setMaskAmex(true);
        }
}

function cleanFchBanco(event,methods,creditCardPago,action){
    methods.setTarjetaTemp(event.target.value);
    methods.setCreditCardPago({
        ...creditCardPago,
        [event.target.name]: event.target.value,
        fchVencimiento: ""
    })
    methods.setBanco("");
    methods.dispatch(action.setDisabledButtonPago("inpFchVencimiento",false));
    methods.dispatch(action.setDisabledButtonPago("inpBanco",false));
}

export const mascaraViMaGen = (event,tid,errorForm,action,creditCardPago,varState,methods) => {
    methods.handlePattern(event, varState.typeNumCard);
    const newTarjet = varState.tarjetaTemp+event.target.value.slice(-1);
    let maskTarjet = "";
    const globalLength = difLength(event.target.value.replace(/ /g, "").length,varState.tarjetaTemp.length);
    if(event.target.value.length === 5 || event.target.value.length === 10 || event.target.value.length === 15){
        maskTarjet = creditCardPago.numeroTarjeta + " *";
    }else {
        maskTarjet = creditCardPago.numeroTarjeta + "*";
    }
    if(event.target.value.length === 0){
        cleanFchBanco(event,methods,creditCardPago,action);
    }else if((!globalLength  && event.target.value !== "") || (globalLength  && event.target.value !== "" && event.target.value.length <= varState.tarjetaTemp.length)){
        methods.setTarjetaTemp(event.target.value);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  "*",
        });
    }else if((event.target.value.replace(/ /g, "").length < varState.tarjetaTemp.length )||
     (event.target.value.replace(/ /g, "").length === varState.tarjetaTemp.length)){
        const newLongTarjet = varState.tarjetaTemp.slice(0,event.target.value.replace(/ /g, "").length);
        methods.setTarjetaTemp(newLongTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  event.target.value,
        });
    }else if(event.target.value.length === 19){
        validRegexpTarjet(event,newTarjet,creditCardPago,varState,methods);
    }else if(event.target.value.length === 15){
        const newt = event.target.value.slice(-1);
        const newM = maskTarjet.slice(0,15);
        const newJ = `${newM}${newt}`;
        methods.setTarjetaTemp(newTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  newJ,
        });
    }else if(event.target.value.length > 15 ){
        methods.setTarjetaTemp(newTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  event.target.value,
        });
    }else{
        methods.setTarjetaTemp(newTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  maskTarjet,
        });
        finalAmex(event,newTarjet,varState,methods);
        nombreBancoBin(event,action,newTarjet,tid,errorForm,methods);
    }
}

function maskTarjetInitial(event,creditCardPago){
    if(event.target.value.length === 5 || event.target.value.length === 12){
        return creditCardPago.numeroTarjeta + " *";
    }else {
        return creditCardPago.numeroTarjeta + "*";
    }
}

export const mascaraAmex = (event,varState,
    action,tid,creditCardPago,errorForm,
    methods) => {
    methods.setTipoTarjeta(varState.amex);
    methods.setTypeNumCard("amex");
    methods.setSizeCvv(4);
    methods.setLongCard(17);
    methods.handlePattern(event, varState.typeNumCard);
    const newTarjet = varState.tarjetaTemp+event.target.value.slice(-1);
    let maskTarjet = "";
    const globalLength = difLength(event.target.value.replace(/ /g, "").length,varState.tarjetaTemp.length);
    if(event.target.value.length === 2 && (!newTarjet.includes("34") || !newTarjet.includes("37"))){
        methods.setTipoTarjeta(varState.visa);
        methods.setTypeNumCard("");
        methods.setSizeCvv(3);
        methods.setLongCard(19);
        methods.setMaskAmex(false);
    }
    maskTarjet = maskTarjetInitial(event,creditCardPago)
    methods.setCreditCardPago({
        ...creditCardPago,
        [event.target.name]: event.target.value
    });
    if(event.target.value.length === 0){
        cleanFchBanco(event,methods,creditCardPago,action);
    }else if((!globalLength  && event.target.value !== "") || (globalLength  && event.target.value !== "" && event.target.value.length <= varState.tarjetaTemp.length)){
        methods.setTarjetaTemp(event.target.value);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  "*"
        });
    }else if((event.target.value.replace(/ /g, "").length < varState.tarjetaTemp.length )|| (event.target.value.replace(/ /g, "").length === varState.tarjetaTemp.length)){
        const newLongTarjet = varState.tarjetaTemp.slice(0,event.target.value.replace(/ /g, "").length);
        methods.setTarjetaTemp(newLongTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  event.target.value
        });
    }
    else if(event.target.value.length > 14 ){
        methods.setTarjetaTemp(newTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  event.target.value
        });
    }else if(event.target.value.length === 17){
        methods.verifyAmex(event,creditCardPago,
            methods
            );
    }
    else{
        methods.setTarjetaTemp(newTarjet);
        methods.setCreditCardPago({
            ...creditCardPago,
            [event.target.name]:  maskTarjet
        });
        finalAmex(event,newTarjet,varState,methods);
        nombreBancoBin(event,action,newTarjet,tid,errorForm,methods);
    }
}

export const errorGenCard = (typeNumCard,errorForm,setForm,dispatch,action) => {
    if( typeNumCard === "gen"){
        setForm({...errorForm,invalidCard: true,numeroTarjeta: false});
        dispatch(action.setDisabledButtonPago("inpNumTarjeta",false));
    }else {
        setForm({...errorForm,invalidCard: false,numeroTarjeta: false});
        dispatch(action.setDisabledButtonPago("inpNumTarjeta",true));
    }
}

function setErrorRequerido(name,dispatch,action){
    switch (name) {
        case "banco":
            dispatch(action.setDisabledButtonPago("inpBanco",false));
            break;
        case "nombreTitular":
            dispatch(action.setDisabledButtonPago("inpNombreTitular",false));
            break;
        case "numeroTarjeta":
            dispatch(action.setDisabledButtonPago("inpNumTarjeta",false));
            break;
        default:
            break;
    }
}

export const errorElseBlur = (event,setForm,errorForm,dispatch,action) => {
    if( event.target.name === "fchVencimiento"){
        setForm({
            ...errorForm,
            [event.target.name]: true,
            invalidFchVencimiento: false
        });
        dispatch(action.setDisabledButtonPago("inpFchVencimiento",false));
    }else {
        setForm({
            ...errorForm,
            [event.target.name]: true,
        });
        setErrorRequerido(event.target.name,dispatch,action);
    }
}

function setErrorFchVencimiento(setForm,errorForm,dispatch,action){
    setForm({...errorForm,
        invalidFchVencimiento: false,
        fchVencimiento: false
    });
dispatch(action.setDisabledButtonPago("inpFchVencimiento", true));
}

export const errorFchVencimiento = (event,creditCardPago,errorForm,anoActual,mesActual,methods,action) => {
    const mes = creditCardPago.fchVencimiento.slice(0,2);
    const anio = creditCardPago.fchVencimiento.slice(3,5);
    const anioActual= anoActual.toString();
    const newMes = mesActual.toString();
    if((parseInt(anio) > parseInt(anioActual.slice(2,4))) && (parseInt(mes) > 0 && parseInt(mes) <= 12)){
        setErrorFchVencimiento(methods.setForm,errorForm,methods.dispatch,action);
    }else if((parseInt(anio) === parseInt(anioActual.slice(2,4))) && (parseInt(mes) > parseInt(newMes) && parseInt(mes) <= 12)){
        setErrorFchVencimiento(methods.setForm,errorForm,methods.dispatch,action);
    }else{
        methods.setForm({
            ...errorForm,
            [event.target.name]: false,
            invalidFchVencimiento: true,
        });
        methods.dispatch(action.setDisabledButtonPago("inpFchVencimiento", false));
    }
}

export const handleCloseErrorPago = (e,setOpenModales,handleCloseCvv,openModales) => {
    if (e === "buttonIcon") {
        setOpenModales({
            ...openModales,
            modalErrorPago: false,
        });
    } else {
        handleCloseCvv();
    }
}

export const handleOptionsCfdi = (methods,action,openModales,responsePago,dataSeguimiento,getDetallePago,global) => {
    methods.dispatch(action.onLoading(true));
    methods.dispatch(action.getFiscalesCfdi(dataSeguimiento.numPoliza, global.tid))
        .then((response) => {
            const responseFiscales = { ...response.data.datosFiscales };
            methods.dispatch(
                action.setDatosEmitirCfdi({
                    datosFiscales: {
                        estatusCfdi: "",
                        idPago: responsePago.idPago,
                        isMoral: responseFiscales.isMoral,
                        nombreRazon: responseFiscales.nombreRazon,
                        apellidoPaterno: responseFiscales.apellidoPaterno,
                        apellidoMaterno: responseFiscales.apellidoMaterno,
                        rfc: responseFiscales.rfc,
                        domicilio: { ...responseFiscales.domicilio },
                    },
                    datosTramite: {
                        numeroPoliza: dataSeguimiento.numPoliza,
                        numeroSiniestro: dataSeguimiento.codSiniestro,
                        marcaVehiculo: responsePago.vehiculo.marcaVehiculo,
                        modelo: responsePago.vehiculo.modelo,
                        placas: responsePago.vehiculo.placas,
                        concepto: "Deducible",
                        monto: getDetallePago.monto,
                        metodoPago: "Tarjeta",
                        numeroTarjeta: responsePago.numTarjeta,
                    },
                })
            );
            methods.setOpenModales({
                ...openModales,
                modalDetalle: false,
            });
            methods.dispatch(action.setCfdi("Emitir"));
        })
        .catch((error) => {
            console.error(error);
            methods.dispatch(action.onLoading(false));
            methods.setDatosModal({
                msjTitle: "Servicio no disponible",
                msjBody: "Intente nuevamente",
            });
            methods.setOpenModales({
                ...openModales,
                modalNotificacion: true,
            });
        });
};

export const closeIconCvvs = (setOpenModales,setCreditCardPago,setForm,setCvvTemp,openModales,creditCardPago,errorForm) => {
    setOpenModales({
        ...openModales,
        modalCvv: false
    });
    setCreditCardPago({
        ...creditCardPago,
        codigoCvv: ""
    });
    setForm({
        ...errorForm,
        codigoCvv: false
    });
    setCvvTemp("");
}

export const handleCorreoNotificarComprobantes = (methods,action,global,responsePago,datosPagoDeducibleAuto,openModales) => {
    methods.dispatch(action.onLoading(true));
    methods.dispatch(
        action.postCorreoNotificarComprobante(
            responsePago.pdfComprobante,
            datosPagoDeducibleAuto.codSiniestroPadre,
            responsePago.authorizationCode,
            global.tid
        )
    )
        .then((response) => {
            methods.setDatosModal({
                msjTitle: mensajesModal.envioExitoso,
                msjBody: mensajesModal.bodyComprobanteExitoso,
                withButtons: {
                    actionButtons: false,
                    msjButton1: "",
                },
            });
            methods.dispatch(action.onLoading(false));
            methods.setOpenModales({
                ...openModales,
                modalNotificacion: true,
            });
        })
        .catch((error) => {
            methods.setDatosModal({
                msjTitle: mensajesModal.envioFallido,
                msjBody: mensajesModal.errorCorreo,
                withButtons: {
                    actionButtons: false,
                    msjButton1: "",
                },
            });
            methods.dispatch(action.onLoading(false));
            methods.setOpenModales({
                ...openModales,
                modalNotificacion: true,
            });
            console.error(error);
        });
}

export const iconCloseDetalles = (setOpenModales,openModales,dispatch,action) => {
    setOpenModales({
        ...openModales,
        modalDetalle: false,
    });
    dispatch(action.setCfdi("Consulta"));  
}

export const handleCloseNotificaciones = (event,setOpenModales,openModales,setDatosModal) => {
    if (event === "buttonIcon") {
        setOpenModales({
            ...openModales,
            modalNotificacion: false,
        });
    }
    setDatosModal({
        msjTitle: "",
        msjBody: "",
        withButton: {
            actionButton: false,
            msjButton1: "",
        },
        tipo: "",
    });
}

export const setDataLinea = (methods,creditCardPago,json,errorForm) => {
    methods.setCreditCardPago({...creditCardPago,
        nombreTitular: json.creditCardPago.nombreTitular,
        numeroTarjeta: json.creditCardPago.numeroTarjeta,
        fchVencimiento: json.creditCardPago.fchVencimiento,
        aceptarCargo: json.aceptarCargo
        });
    methods.setTarjetaTemp(json.tarjetaTemp);
    methods.setTipoTarjeta(json.tipoTarjeta);
    methods.setSizeCvv(json.sizeCvv);
    methods.setTypeNumCard(json.typeNumCard);
    methods.setLongCard(json.longCard);
    methods.setBanco(json.banco);
    methods.setMaskAmex(json.maskAmex);
    methods.setTipoTarjetaPago(json.tipoTarjetaPago);
    methods.setForm({
        ...errorForm,
        nombreTitular: json.errorForm.nombreTitular,
        numeroTarjeta: json.errorForm.nombreTitular,
        banco: json.errorForm.nombreTitular,
        fchVencimiento: json.errorForm.nombreTitular,
        invalidFchVencimiento: json.errorForm.nombreTitular,
        invalidCard: json.errorForm.nombreTitular,
    })
}


// WEBPACK FOOTER //
// ./src/pago-deducible-auto/pago/utils.js